export function findInCollection(collections: Array<Object>, findKey: string | any, findValue: string | any): Object | any | null {
  return collections.find((collection: Object) => {
    return collection[findKey] === findValue;
  });
}
